import { useState } from 'react';
import { categories, posts, type Post } from '@/mocks/entertainment';

function badge(tone: Post['badgeTone'], text: string) {
  const map: Record<string, string> = {
    primary: 'bg-primary-500 text-background-50',
    accent: 'bg-accent-500 text-background-50',
    secondary: 'bg-secondary-500 text-background-50',
  };
  return <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${map[tone]}`}>{text}</span>;
}

export default function CategorySection() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? posts.slice(0, 6) : posts.filter((p) => p.cat === active);

  return (
    <section id="column" className="mx-auto max-w-7xl px-4 md:px-6 pt-16 md:pt-24">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <p className="text-xs font-bold tracking-widest text-primary-600 mb-2">COLUMNS</p>
        <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">分类栏目 · 想吃哪个瓜随便挑</h3>
        <p className="mt-2 text-sm text-foreground-600">从明星动态到时尚红毯，每个频道都给你安排得明明白白。</p>
      </div>

      <div className="flex flex-wrap justify-center gap-2 mb-8">
        {categories.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => setActive(c.key)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition whitespace-nowrap ${
              active === c.key
                ? 'bg-primary-500 text-background-50 shadow-soft'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>

      <div key={active} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 animate-fade-up">
        {list.map((p) => (
          <a
            key={`${active}-${p.id}`}
            href="#contact"
            className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition flex flex-col"
          >
            <div className="relative overflow-hidden h-44">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold">{p.catName}</span>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="mb-2">{badge(p.badgeTone, p.badge)}</div>
              <h4 className="text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition">{p.title}</h4>
              <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{p.summary}</p>
              <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{p.minutes} 分钟前 · {p.views} 阅读</span>
                <i className="ri-arrow-right-line text-primary-600 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}